export const postAppEvent = async ({ sessionId, inAppEvent }) => {
    for (const event of inAppEvent) {
        const appEvent = { ...event, session_id: sessionId }
        await fetch('https://s.tangent.ai/track', {
            method: "post",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(appEvent)
        }
        )
    }
}

export const getSessionID = async (params: { client_name: string; formId: string }) => {
    // const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
    try {
        const response = await fetch(`https://s.tangent.ai/track?client=${params.client_name}&form_id=${params.formId}`, {
            method: "get"
        })

        if (!response.ok) {
            throw new Error('Failed to get session ID')
        }
        return await response.json();
        // await delay(5000);
    } catch (error) {
        console.log(error, "session id error")
        return null
    }
}